import { render } from "./Supervisor.vue?vue&type=template&id=112998aa&scoped=true"
import script from "./Supervisor.vue?vue&type=script&lang=js"
export * from "./Supervisor.vue?vue&type=script&lang=js"

import "./Supervisor.vue?vue&type=style&index=0&id=112998aa&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-112998aa"]])

export default __exports__